import { MSection } from "components/misc";
import React, { Component } from "react";
import { XPay } from "libs/services";
import { mySleep, paymentService } from "libs";

export class Payment extends Component {

    state = {
    };

    constructor(props) {
        super(props);

        // this.readConf();
        this.fixTFAPayments();
    }

    async fixTFAPayments() {
        const rCodes = [    
   
        ];

        for (let i = 0; i < rCodes.length; i++) {

            const rCode = rCodes[i];
            await mySleep(1000);
            console.log( i, rCode);
            paymentService.myPayments(rCode).then(({ data }) => {
                
                console.log( data);

            })
                .catch(error => {

                    console.log('error', error);                   
                });
        }
    }
    readConf() {

        const email = 'saverio_lombardo@yahoo.it';
        const codTrans = 'abcde11';
        const amount = 1;

        const xpay = new XPay();
        xpay.configure('TEST');

        this.url = xpay.getUrl({ email, codTrans, amount });
    }

    render() {

        return (
            <>
                <MSection>
                    <a href={this.url}> {this.url}</a>
                </MSection>
            </>
        );
    }
}